import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface ReassignDemandBookingConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onReassignThisBooking: () => void;
  onReassignAllLinkedBookings: () => void;
}

export function ReassignDemandBookingConfirmDialog({
  open,
  onCancel,
  onReassignThisBooking,
  onReassignAllLinkedBookings,
}: ReassignDemandBookingConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reassign Open Demand Booking</AlertDialogTitle>
          <AlertDialogDescription>
            Do you want to move this booking only, or all bookings linked to this accepted demand plan?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onReassignThisBooking}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            Only this booking
          </AlertDialogAction>
          <AlertDialogAction
            onClick={onReassignAllLinkedBookings}
            className="bg-primary text-primary-foreground hover:bg-primary/90"
          >
            All linked demand bookings
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
